export type Lang = 'sr' | 'en';
export type TranslationKeys =
  | 'shoppingCart'
  | 'checkout'
  | 'topup'
  | 'overview'
  | 'transactionOverview'
  | 'transactionStatus'
  | 'contract';

export const CheckoutSteps: Record<Lang, Record<TranslationKeys, string>> = {
  sr: {
    shoppingCart: 'Korpa',
    checkout: 'Kupovina',
    topup: 'Online-dopune',
    overview: 'Pregled',
    transactionOverview: 'Pregled-kupovine',
    transactionStatus: 'Status-transakcije',
    contract: 'Ugovor',
  },
  en: {
    shoppingCart: 'Shopping-cart',
    checkout: 'Checkout',
    topup: 'Online-topups',
    overview: 'Overview',
    transactionOverview: 'Transaction-overview',
    transactionStatus: 'Transaction-status',
    contract: 'Contract',
  },
} as const;

export default CheckoutSteps;
